//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React from "react";

const AdminModalFooter = ({ handleRefresh, button1, button2, children }) => (
  <div className="row">
    <div className="col-md-2">
      {handleRefresh ? (
        <button
          className="btn btn-default btn-sm"
          title="refresh the list of tutors for this request"
          onClick={handleRefresh}
        >
          Refresh
        </button>
      ) : null}
    </div>
    <div className="col-md-2" />
    <div className="col-md-8" style={{ textAlign: "right" }}>
      {children ? (
        children
      ) : (
        <>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            data-dismiss="modal"
            style={{ marginRight: "10px" }}
            title="close modal"
          >
            Close
          </button>
          {button1()}
          {button2()}
        </>
      )}
    </div>
  </div>
);

export default observer(AdminModalFooter);
